// Knex stored /n in DB for newline characters.
export default function fixLines(value) {
  const newLine = /(\\+)n/g;
  return value ? value.replace(newLine, '\n') : value;
}



// WEBPACK FOOTER //
// ./shared/lib/fixLines.js